import type { RechercheStore } from '@/features/interface/recherches/shared/composables/storeRechercheBuilder.ts'
import { usePreferencesUtilisateur } from '@/features/application/preferences'
import { type PreferenceGlobale, PREFERENCES_UTILISATEUR_APP } from '@/features/application/types.ts'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import { pageSizeItems } from '@/features/interface/recherches/shared'

export const usePagination = (store: RechercheStore<any, any>) => {
  const { setupFieldWithOptions, setupFieldWithKey } = store
  const { pageData, pageRequest } = storeToRefs(store)
  const prefService = usePreferencesUtilisateur<PreferenceGlobale>(PREFERENCES_UTILISATEUR_APP)

  const pageSize = setupFieldWithOptions<number | null | undefined>({
    getValue: (model) => model.pagination?.pageSize,
    setPatch: (patch, value) => {
      patch.pagination = {
        pageNumber: 1,
        pageSize: value!,
      }
      void prefService.setPreferencesAsync({ pageSize: value! })
    },
  })
  const pageNumber = setupFieldWithKey<number>('pagination.pageNumber')
  const pageChange = (page: number) => {
    pageNumber.value = page
  }
  const pageCount = computed(() => {
    if (pageData.value?.totalRecords) {
      return Math.ceil(pageData.value?.totalRecords / pageRequest.value!.pagination!.pageSize!)
    }
    return 0
  })

  /* calcule si la pagination est visible ou pas */
  const pageSizeMin = pageSizeItems
    .map(item => item.id)
    .reduce((acc, cur) => Math.min(acc, cur), Number.MAX_SAFE_INTEGER)
  const pageSizeVisible = computed(() => pageSizeMin < (pageData.value?.totalRecords ?? 0))

  return { pageChange, pageCount, pageNumber, pageSize, pageSizeVisible }
}
